import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogActions } from 'src/app/model/dictionary';
import { TranslocoService } from '@jsverse/transloco';
@Component({
  selector: 'app-contact-info-dialog',
  templateUrl: './contact-info-dialog.component.html',
  styleUrls: ['./contact-info-dialog.component.scss']
})
export class ContactInfoDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<ContactInfoDialogComponent>,
    private translateService: TranslocoService
  ) {
  }

  doConfirm() {
    this.dialogRef.close({ event: DialogActions.CONFIRM });
  }

  getEmailText(translationString:string) : string{
    return "mailto:"+this.translateService.translate(translationString)
  }
}
